function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
 * International Telephone Input v8.5.2
 * https://github.com/jackocnr/intl-tel-input.git
 * Licensed under the MIT license
 */
// wrap in UMD - see https://github.com/umdjs/umd/blob/master/jqueryPluginCommonjs.js
(function (factory) {
  if (typeof define === "function" && define.amd) {
    define(["jquery"], function ($) {
      factory($, window, document);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && module.exports) {
    module.exports = factory(require("jquery"), window, document);
  } else {
    factory(jQuery, window, document);
  }
})(function ($, window, document, undefined) {
  "use strict"; // these vars persist through all instances of the plugin

  var pluginName = "intlTelInput",
      id = 1,
      // give each instance it's own id for namespaced event handling
  defaults = {
    // whether or not to allow the dropdown
    allowDropdown: true,
    // if there is just a dial code in the input: remove it on blur, and re-add it on focus
    autoHideDialCode: true,
    // add or remove input placeholder with an example number for the selected country
    autoPlaceholder: true,
    // modify the auto placeholder
    customPlaceholder: null,
    // append menu to a specific element
    dropdownContainer: "",
    // don't display these countries
    excludeCountries: [],
    // format the input value during initialisation
    formatOnInit: true,
    // geoIp lookup function
    geoIpLookup: null,
    // initial country
    initialCountry: "",
    // don't insert international dial codes
    nationalMode: true,
    // number type to use for placeholders
    numberType: "MOBILE",
    // display only these countries
    onlyCountries: [],
    // the countries at the top of the list. defaults to united states and united kingdom
    preferredCountries: ["us", "gb"],
    // display the country dial code next to the selected flag so it's not part of the typed number
    separateDialCode: false,
    // specify the path to the libphonenumber script to enable validation/formatting
    utilsScript: ""
  },
      keys = {
    UP: 38,
    DOWN: 40,
    ENTER: 13,
    ESC: 27,
    PLUS: 43,
    A: 65,
    Z: 90,
    SPACE: 32,
    TAB: 9
  }; // keep track of if the window.load event has fired as impossible to check after the fact

  $(window).load(function () {
    // UPDATE: use a public static field so we can fudge it in the tests
    $.fn[pluginName].windowLoaded = true;
  });

  function Plugin(element, options) {
    this.telInput = $(element);
    this.options = $.extend({}, defaults, options); // event namespace

    this.ns = "." + pluginName + id++; // Chrome, FF, Safari, IE9+

    this.isGoodBrowser = Boolean(element.setSelectionRange);
    this.hadInitialPlaceholder = Boolean($(element).attr("placeholder"));
  }

  Plugin.prototype = {
    _init: function _init() {
      // if in nationalMode, disable options relating to dial codes
      if (this.options.nationalMode) {
        this.options.autoHideDialCode = false;
      } // if separateDialCode then doesn't make sense to A) insert dial code into input (autoHideDialCode), and B) display national numbers (because we're displaying the country dial code next to them)


      if (this.options.separateDialCode) {
        this.options.autoHideDialCode = this.options.nationalMode = false; // let's force this for now for simplicity - we can support this later if need be

        this.options.allowDropdown = true;
      } // we cannot just test screen size as some smartphones/website meta tags will report desktop resolutions
      // Note: for some reason jasmine breaks if you put this in the main Plugin function with the rest of these declarations
      // Note: to target Android Mobiles (and not Tablets), we must find "Android" and "Mobile"


      this.isMobile = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

      if (this.isMobile) {
        // trigger the mobile dropdown css
        $("body").addClass("iti-mobile"); // on mobile, we want a full screen dropdown, so we must append it to the body

        if (!this.options.dropdownContainer) {
          this.options.dropdownContainer = "body";
        }
      } // we return these deferred objects from the _init() call so they can be watched, and then we resolve them when each specific request returns
      // Note: again, jasmine breaks when I put these in the Plugin function


      this.autoCountryDeferred = new $.Deferred();
      this.utilsScriptDeferred = new $.Deferred(); // process all the data: onlyCountries, excludeCountries, preferredCountries etc

      this._processCountryData(); // generate the markup


      this._generateMarkup(); // set the initial state of the input value and the selected flag


      this._setInitialState(); // start all of the event listeners: autoHideDialCode, input keydown, selectedFlag click


      this._initListeners(); // utils script, and auto country


      this._initRequests(); // return the deferreds


      return [this.autoCountryDeferred, this.utilsScriptDeferred];
    },

    /********************
    *  PRIVATE METHODS
    ********************/
    // prepare all of the country data, including onlyCountries, excludeCountries and preferredCountries options
    _processCountryData: function _processCountryData() {
      // process onlyCountries or excludeCountries array if present
      this._processAllCountries(); // process the countryCodes map


      this._processCountryCodes(); // process the preferredCountries


      this._processPreferredCountries();
    },
    // add a country code to this.countryCodes
    _addCountryCode: function _addCountryCode(iso2, dialCode, priority) {
      if (!(dialCode in this.countryCodes)) {
        this.countryCodes[dialCode] = [];
      }

      var index = priority || 0;
      this.countryCodes[dialCode][index] = iso2;
    },
    // filter the given countries using the process function
    _filterCountries: function _filterCountries(countryArray, processFunc) {
      var i; // standardise case

      for (i = 0; i < countryArray.length; i++) {
        countryArray[i] = countryArray[i].toLowerCase();
      } // build instance country array


      this.countries = [];

      for (i = 0; i < allCountries.length; i++) {
        if (processFunc($.inArray(allCountries[i].iso2, countryArray))) {
          this.countries.push(allCountries[i]);
        }
      }
    },
    // process onlyCountries or excludeCountries array if present
    _processAllCountries: function _processAllCountries() {
      if (this.options.onlyCountries.length) {
        // process onlyCountries option
        this._filterCountries(this.options.onlyCountries, function (inArray) {
          // if country is in array
          return inArray != -1;
        });
      } else if (this.options.excludeCountries.length) {
        // process excludeCountries option
        this._filterCountries(this.options.excludeCountries, function (inArray) {
          // if country is not in array
          return inArray == -1;
        });
      } else {
        this.countries = allCountries;
      }
    },
    // process the countryCodes map
    _processCountryCodes: function _processCountryCodes() {
      this.countryCodes = {};

      for (var i = 0; i < this.countries.length; i++) {
        var c = this.countries[i];

        this._addCountryCode(c.iso2, c.dialCode, c.priority); // area codes


        if (c.areaCodes) {
          for (var j = 0; j < c.areaCodes.length; j++) {
            // full dial code is country code + dial code
            this._addCountryCode(c.iso2, c.dialCode + c.areaCodes[j]);
          }
        }
      }
    },
    // process preferred countries - iterate through the preferences, fetching the country data for each one
    _processPreferredCountries: function _processPreferredCountries() {
      this.preferredCountries = [];

      for (var i = 0; i < this.options.preferredCountries.length; i++) {
        var countryCode = this.options.preferredCountries[i].toLowerCase(),
            countryData = this._getCountryData(countryCode, false, true);

        if (countryData) {
          this.preferredCountries.push(countryData);
        }
      }
    },
    // generate all of the markup for the plugin: the selected flag overlay, and the dropdown
    _generateMarkup: function _generateMarkup() {
      // prevent autocomplete as there's no safe, cross-browser event we can react to, so it can easily put the plugin in an inconsistent state e.g. the wrong flag selected for the autocompleted number, which on submit could mean the wrong number is saved (esp in nationalMode)
      this.telInput.attr("autocomplete", "off"); // containers (mostly for positioning)

      var parentClass = "intl-tel-input";

      if (this.options.allowDropdown) {
        parentClass += " allow-dropdown";
      }

      if (this.options.separateDialCode) {
        parentClass += " separate-dial-code";
      }

      this.telInput.wrap($("<div>", {
        "class": parentClass
      }));
      this.flagsContainer = $("<div>", {
        "class": "flag-container"
      }).insertBefore(this.telInput); // currently selected flag (displayed to left of input)

      var selectedFlag = $("<div>", {
        "class": "selected-flag"
      });
      selectedFlag.appendTo(this.flagsContainer);
      this.selectedFlagInner = $("<div>", {
        "class": "iti-flag"
      }).appendTo(selectedFlag);

      if (this.options.separateDialCode) {
        this.selectedDialCode = $("<div>", {
          "class": "selected-dial-code"
        }).appendTo(selectedFlag);
      }

      if (this.options.allowDropdown) {
        // make element focusable and tab naviagable
        selectedFlag.attr("tabindex", "0"); // CSS triangle

        $("<div>", {
          "class": "iti-arrow"
        }).appendTo(selectedFlag); // country dropdown: preferred countries, then divider, then all countries

        this.countryList = $("<ul>", {
          "class": "country-list hide"
        });

        if (this.preferredCountries.length) {
          this._appendListItems(this.preferredCountries, "preferred");

          $("<li>", {
            "class": "divider"
          }).appendTo(this.countryList);
        }

        this._appendListItems(this.countries, ""); // this is useful in lots of places


        this.countryListItems = this.countryList.children(".country"); // create dropdownContainer markup

        if (this.options.dropdownContainer) {
          this.dropdown = $("<div>", {
            "class": "intl-tel-input iti-container"
          }).append(this.countryList);
        } else {
          this.countryList.appendTo(this.flagsContainer);
        }
      } else {
        // a little hack so we don't break anything
        this.countryListItems = $();
      }
    },
    // add a country <li> to the countryList <ul> container
    _appendListItems: function _appendListItems(countries, className) {
      // we create so many DOM elements, it is faster to build a temp string
      // and then add everything to the DOM in one go at the end
      var tmp = ""; // for each country

      for (var i = 0; i < countries.length; i++) {
        var c = countries[i]; // open the list item

        tmp += "<li class='country " + className + "' data-dial-code='" + c.dialCode + "' data-country-code='" + c.iso2 + "'>"; // add the flag

        tmp += "<div class='flag-box'><div class='iti-flag " + c.iso2 + "'></div></div>"; // and the country name and dial code

        tmp += "<span class='country-name'>" + c.name + "</span>";
        tmp += "<span class='dial-code'>+" + c.dialCode + "</span>"; // close the list item

        tmp += "</li>";
      }

      this.countryList.append(tmp);
    },
    // set the initial state of the input value and the selected flag by:
    // 1. extracting a dial code from the given number
    // 2. using explicit initialCountry
    // 3. picking the first preferred country
    // 4. picking the first country
    _setInitialState: function _setInitialState() {
      var val = this.telInput.val(); // if we already have a dial code we can go ahead and set the flag, else fall back to default

      if (this._getDialCode(val)) {
        this._updateFlagFromNumber(val, true);
      } else if (this.options.initialCountry !== "auto") {
        // see if we should select a flag
        if (this.options.initialCountry) {
          this._setFlag(this.options.initialCountry, true);
        } else {
          // no dial code and no initialCountry, so default to first in list
          this.defaultCountry = this.preferredCountries.length ? this.preferredCountries[0].iso2 : this.countries[0].iso2;

          if (!val) {
            this._setFlag(this.defaultCountry, true);
          }
        } // if empty and no nationalMode and no autoHideDialCode then insert the default dial code


        if (!val && !this.options.nationalMode && !this.options.autoHideDialCode && !this.options.separateDialCode) {
          this.telInput.val("+" + this.selectedCountryData.dialCode);
        }
      } // NOTE: if initialCountry is set to auto, that will be handled separately
      // format


      if (val) {
        // this wont be run after _updateDialCode as that's only called if no val
        this._updateValFromNumber(val, this.options.formatOnInit);
      }
    },
    // initialise the main event listeners: input keyup, and click selected flag
    _initListeners: function _initListeners() {
      this._initKeyListeners();

      if (this.options.autoHideDialCode) {
        this._initFocusListeners();
      }

      if (this.options.allowDropdown) {
        this._initDropdownListeners();
      }
    },
    // initialise the dropdown listeners
    _initDropdownListeners: function _initDropdownListeners() {
      var that = this; // hack for input nested inside label: clicking the selected-flag to open the dropdown would then automatically trigger a 2nd click on the input which would close it again

      var label = this.telInput.closest("label");

      if (label.length) {
        label.on("click" + this.ns, function (e) {
          // if the dropdown is closed, then focus the input, else ignore the click
          if (that.countryList.hasClass("hide")) {
            that.telInput.focus();
          } else {
            e.preventDefault();
          }
        });
      } // toggle country dropdown on click


      var selectedFlag = this.selectedFlagInner.parent();
      selectedFlag.on("click" + this.ns, function (e) {
        // only intercept this event if we're opening the dropdown
        // else let it bubble up to the top ("click-off-to-close" listener)
        // we cannot just stopPropagation as it may be needed to close another instance
        if (that.countryList.hasClass("hide") && !that.telInput.prop("disabled") && !that.telInput.prop("readonly")) {
          that._showDropdown();
        }
      }); // open dropdown list if currently focused

      this.flagsContainer.on("keydown" + that.ns, function (e) {
        var isDropdownHidden = that.countryList.hasClass("hide");

        if (isDropdownHidden && (e.which == keys.UP || e.which == keys.DOWN || e.which == keys.SPACE || e.which == keys.ENTER)) {
          // prevent form from being submitted if "ENTER" was pressed
          e.preventDefault(); // prevent event from being handled again by document

          e.stopPropagation();

          that._showDropdown();
        } // allow navigation from dropdown to input on TAB


        if (e.which == keys.TAB) {
          that._closeDropdown();
        }
      });
    },
    // init many requests: utils script / geo ip lookup
    _initRequests: function _initRequests() {
      var that = this; // if the user has specified the path to the utils script, fetch it on window.load, else resolve

      if (this.options.utilsScript) {
        // if the plugin is being initialised after the window.load event has already been fired
        if ($.fn[pluginName].windowLoaded) {
          $.fn[pluginName].loadUtils(this.options.utilsScript, this.utilsScriptDeferred);
        } else {
          // wait until the load event so we don't block any other requests e.g. the flags image
          $(window).load(function () {
            $.fn[pluginName].loadUtils(that.options.utilsScript, that.utilsScriptDeferred);
          });
        }
      } else {
        this.utilsScriptDeferred.resolve();
      }

      if (this.options.initialCountry === "auto") {
        this._loadAutoCountry();
      } else {
        this.autoCountryDeferred.resolve();
      }
    },
    // perform the geo ip lookup
    _loadAutoCountry: function _loadAutoCountry() {
      var that = this; // check for cookie

      var cookieAutoCountry = window.Cookies ? Cookies.get("itiAutoCountry") : "";

      if (cookieAutoCountry) {
        $.fn[pluginName].autoCountry = cookieAutoCountry;
      } // 3 options:
      // 1) already loaded (we're done)
      // 2) not already started loading (start)
      // 3) already started loading (do nothing - just wait for loading callback to fire)


      if ($.fn[pluginName].autoCountry) {
        this.handleAutoCountry();
      } else if (!$.fn[pluginName].startedLoadingAutoCountry) {
        // don't do this twice!
        $.fn[pluginName].startedLoadingAutoCountry = true;

        if (typeof this.options.geoIpLookup === "function") {
          this.options.geoIpLookup(function (countryCode) {
            $.fn[pluginName].autoCountry = countryCode.toLowerCase();

            if (window.Cookies) {
              Cookies.set("itiAutoCountry", $.fn[pluginName].autoCountry, {
                path: "/"
              });
            } // tell all instances the auto country is ready
            // TODO: this should just be the current instances
            // UPDATE: use setTimeout in case their geoIpLookup function calls this callback straight away (e.g. if they have already done the geo ip lookup somewhere else). Using setTimeout means that the current thread of execution will finish before executing this, which allows the plugin to finish initialising.


            setTimeout(function () {
              $(".intl-tel-input input").intlTelInput("handleAutoCountry");
            });
          });
        }
      }
    },
    // initialize any key listeners
    _initKeyListeners: function _initKeyListeners() {
      var that = this; // update flag on keyup
      // (keep this listener separate otherwise the setTimeout breaks all the tests)

      this.telInput.on("keyup" + this.ns, function () {
        that._updateFlagFromNumber(that.telInput.val());
      }); // update flag on cut/paste events (now supported in all major browsers)

      this.telInput.on("cut" + this.ns + " paste" + this.ns + " keyup" + this.ns, function () {
        // hack because "paste" event is fired before input is updated
        setTimeout(function () {
          that._updateFlagFromNumber(that.telInput.val());
        });
      });
    },
    // adhere to the input's maxlength attr
    _cap: function _cap(number) {
      var max = this.telInput.attr("maxlength");
      return max && number.length > max ? number.substr(0, max) : number;
    },
    // listen for mousedown, focus and blur
    _initFocusListeners: function _initFocusListeners() {
      var that = this; // mousedown decides where the cursor goes, so if we're focusing we must preventDefault as we'll be inserting the dial code, and we want the cursor to be at the end no matter where they click

      this.telInput.on("mousedown" + this.ns, function (e) {
        if (!that.telInput.is(":focus") && !that.telInput.val()) {
          e.preventDefault(); // but this also cancels the focus, so we must trigger that manually

          that.telInput.focus();
        }
      }); // on focus: if empty, insert the dial code for the currently selected flag

      this.telInput.on("focus" + this.ns, function (e) {
        if (!that.telInput.val() && !that.telInput.prop("readonly") && that.selectedCountryData.dialCode) {
          // insert the dial code
          that.telInput.val("+" + that.selectedCountryData.dialCode); // after auto-inserting a dial code, if the first key they hit is '+' then assume they are entering a new number, so remove the dial code. use keypress instead of keydown because keydown gets triggered for the shift key (required to hit the + key), and instead of keyup because that shows the new '+' before removing the old one

          that.telInput.one("keypress.plus" + that.ns, function (e) {
            if (e.which == keys.PLUS) {
              that.telInput.val("");
            }
          }); // after tabbing in, make sure the cursor is at the end we must use setTimeout to get outside of the focus handler as it seems the selection happens after that

          setTimeout(function () {
            var input = that.telInput[0];

            if (that.isGoodBrowser) {
              var len = that.telInput.val().length;
              input.setSelectionRange(len, len);
            }
          });
        }
      }); // on blur or form submit: if just a dial code then remove it

      var form = this.telInput.prop("form");

      if (form) {
        $(form).on("submit" + this.ns, function () {
          that._removeEmptyDialCode();
        });
      }

      this.telInput.on("blur" + this.ns, function () {
        that._removeEmptyDialCode();
      });
    },
    _removeEmptyDialCode: function _removeEmptyDialCode() {
      var value = this.telInput.val(),
          startsPlus = value.charAt(0) == "+";

      if (startsPlus) {
        var numeric = this._getNumeric(value); // if just a plus, or if just a dial code


        if (!numeric || this.selectedCountryData.dialCode == numeric) {
          this.telInput.val("");
        }
      } // remove the keypress listener we added on focus


      this.telInput.off("keypress.plus" + this.ns);
    },
    // extract the numeric digits from the given string
    _getNumeric: function _getNumeric(s) {
      return s.replace(/\D/g, "");
    },
    // show the dropdown
    _showDropdown: function _showDropdown() {
      this._setDropdownPosition(); // update highlighting and scroll to active list item


      var activeListItem = this.countryList.children(".active");

      if (activeListItem.length) {
        this._highlightListItem(activeListItem);

        this._scrollTo(activeListItem);
      } // bind all the dropdown-related listeners: mouseover, click, click-off, keydown


      this._bindDropdownListeners(); // update the arrow


      this.selectedFlagInner.children(".iti-arrow").addClass("up");
    },
    // decide where to position dropdown (depends on position within viewport, and scroll)
    _setDropdownPosition: function _setDropdownPosition() {
      var that = this;

      if (this.options.dropdownContainer) {
        this.dropdown.appendTo(this.options.dropdownContainer);
      } // show the menu and grab the dropdown height


      this.dropdownHeight = this.countryList.removeClass("hide").outerHeight();

      if (!this.isMobile) {
        var pos = this.telInput.offset(),
            inputTop = pos.top,
            windowTop = $(window).scrollTop(),
            // dropdownFitsBelow = (dropdownBottom < windowBottom)
        dropdownFitsBelow = inputTop + this.telInput.outerHeight() + this.dropdownHeight < windowTop + $(window).height(),
            dropdownFitsAbove = inputTop - this.dropdownHeight > windowTop; // by default, the dropdown will be below the input. If we want to position it above the input, we add the dropup class.

        this.countryList.toggleClass("dropup", !dropdownFitsBelow && dropdownFitsAbove); // if dropdownContainer is enabled, calculate postion

        if (this.options.dropdownContainer) {
          // by default the dropdown will be directly over the input because it's not in the flow. If we want to position it below, we need to add some extra top value.
          var extraTop = !dropdownFitsBelow && dropdownFitsAbove ? 0 : this.telInput.innerHeight(); // calculate placement

          this.dropdown.css({
            top: inputTop + extraTop,
            left: pos.left
          }); // close menu on window scroll

          $(window).on("scroll" + this.ns, function () {
            that._closeDropdown();
          });
        }
      }
    },
    // we only bind dropdown listeners when the dropdown is open
    _bindDropdownListeners: function _bindDropdownListeners() {
      var that = this; // when mouse over a list item, just highlight that one
      // we add the class "highlight", so if they hit "enter" we know which one to select

      this.countryList.on("mouseover" + this.ns, ".country", function (e) {
        that._highlightListItem($(this));
      }); // listen for country selection

      this.countryList.on("click" + this.ns, ".country", function (e) {
        that._selectListItem($(this));
      }); // click off to close
      // (except when this initial opening click is bubbling up)
      // we cannot just stopPropagation as it may be needed to close another instance

      var isOpening = true;
      $("html").on("click" + this.ns, function (e) {
        if (!isOpening) {
          that._closeDropdown();
        }

        isOpening = false;
      }); // listen for up/down scrolling, enter to select, or letters to jump to country name.
      // use keydown as keypress doesn't fire for non-char keys and we want to catch if they
      // just hit down and hold it to scroll down (no keyup event).
      // listen on the document because that's where key events are triggered if no input has focus

      var query = "",
          queryTimer = null;
      $(document).on("keydown" + this.ns, function (e) {
        // prevent down key from scrolling the whole page,
        // and enter key from submitting a form etc
        e.preventDefault();

        if (e.which == keys.UP || e.which == keys.DOWN) {
          // up and down to navigate
          that._handleUpDownKey(e.which);
        } else if (e.which == keys.ENTER) {
          // enter to select
          that._handleEnterKey();
        } else if (e.which == keys.ESC) {
          // esc to close
          that._closeDropdown();
        } else if (e.which >= keys.A && e.which <= keys.Z || e.which == keys.SPACE) {
          // upper case letters (note: keyup/keydown only return upper case letters)
          // jump to countries that start with the query string
          if (queryTimer) {
            clearTimeout(queryTimer);
          }

          query += String.fromCharCode(e.which);

          that._searchForCountry(query); // if the timer hits 1 second, reset the query


          queryTimer = setTimeout(function () {
            query = "";
          }, 1e3);
        }
      });
    },
    // highlight the next/prev item in the list (and ensure it is visible)
    _handleUpDownKey: function _handleUpDownKey(key) {
      var current = this.countryList.children(".highlight").first();
      var next = key == keys.UP ? current.prev() : current.next();

      if (next.length) {
        // skip the divider
        if (next.hasClass("divider")) {
          next = key == keys.UP ? next.prev() : next.next();
        }

        this._highlightListItem(next);

        this._scrollTo(next);
      }
    },
    // select the currently highlighted item
    _handleEnterKey: function _handleEnterKey() {
      var currentCountry = this.countryList.children(".highlight").first();

      if (currentCountry.length) {
        this._selectListItem(currentCountry);
      }
    },
    // find the first list item whose name starts with the query string
    _searchForCountry: function _searchForCountry(query) {
      for (var i = 0; i < this.countries.length; i++) {
        if (this._startsWith(this.countries[i].name, query)) {
          var listItem = this.countryList.children("[data-country-code=" + this.countries[i].iso2 + "]").not(".preferred"); // update highlighting and scroll

          this._highlightListItem(listItem);

          this._scrollTo(listItem, true);

          break;
        }
      }
    },
    // check if (uppercase) string a starts with string b
    _startsWith: function _startsWith(a, b) {
      return a.substr(0, b.length).toUpperCase() == b;
    },
    // update the input's value to the given val (format first if possible)
    // NOTE: this is called from _setInitialState, handleUtils and setNumber
    _updateValFromNumber: function _updateValFromNumber(number, doFormat, format) {
      if (doFormat && window.intlTelInputUtils && this.selectedCountryData) {
        if (!$.isNumeric(format)) {
          format = !this.options.separateDialCode && (this.options.nationalMode || number.charAt(0) != "+") ? intlTelInputUtils.numberFormat.NATIONAL : intlTelInputUtils.numberFormat.INTERNATIONAL;
        }

        number = intlTelInputUtils.formatNumber(number, this.selectedCountryData.iso2, format);
      }

      number = this._beforeSetNumber(number);
      this.telInput.val(number);
    },
    // check if need to select a new flag based on the given number
    // Note: called from _setInitialState, keyup handler, setNumber
    _updateFlagFromNumber: function _updateFlagFromNumber(number, isInit) {
      // if we're in nationalMode and we already have US/Canada selected, make sure the number starts with a +1 so _getDialCode will be able to extract the area code
      // update: if we dont yet have selectedCountryData, but we're here (trying to update the flag from the number), that means we're initialising the plugin with a number that already has a dial code, so fine to ignore this bit
      if (number && this.options.nationalMode && this.selectedCountryData && this.selectedCountryData.dialCode == "1" && number.charAt(0) != "+") {
        if (number.charAt(0) != "1") {
          number = "1" + number;
        }

        number = "+" + number;
      } // try and extract valid dial code from input


      var dialCode = this._getDialCode(number),
          countryCode = null;

      if (dialCode) {
        // check if one of the matching countries is already selected
        var countryCodes = this.countryCodes[this._getNumeric(dialCode)],
            alreadySelected = this.selectedCountryData && $.inArray(this.selectedCountryData.iso2, countryCodes) != -1; // if a matching country is not already selected (or this is an unknown NANP area code): choose the first in the list


        if (!alreadySelected || this._isUnknownNanp(number, dialCode)) {
          // if using onlyCountries option, countryCodes[0] may be empty, so we must find the first non-empty index
          for (var j = 0; j < countryCodes.length; j++) {
            if (countryCodes[j]) {
              countryCode = countryCodes[j];
              break;
            }
          }
        }
      } else if (number.charAt(0) == "+" && this._getNumeric(number).length) {
        // invalid dial code, so empty
        // Note: use getNumeric here because the number has not been formatted yet, so could contain bad chars
        countryCode = "";
      } else if (!number || number == "+") {
        // empty, or just a plus, so default
        countryCode = this.defaultCountry;
      }

      if (countryCode !== null) {
        this._setFlag(countryCode, isInit);
      }
    },
    // check if the given number contains an unknown area code from the North American Numbering Plan i.e. the only dialCode that could be extracted was +1 (instead of say +1 702) and the actual number's length is >=4
    _isUnknownNanp: function _isUnknownNanp(number, dialCode) {
      return dialCode == "+1" && this._getNumeric(number).length >= 4;
    },
    // remove highlighting from other list items and highlight the given item
    _highlightListItem: function _highlightListItem(listItem) {
      this.countryListItems.removeClass("highlight");
      listItem.addClass("highlight");
    },
    // find the country data for the given country code
    // the ignoreOnlyCountriesOption is only used during init() while parsing the onlyCountries array
    _getCountryData: function _getCountryData(countryCode, ignoreOnlyCountriesOption, allowFail) {
      var countryList = ignoreOnlyCountriesOption ? allCountries : this.countries;

      for (var i = 0; i < countryList.length; i++) {
        if (countryList[i].iso2 == countryCode) {
          return countryList[i];
        }
      }

      if (allowFail) {
        return null;
      } else {
        throw new Error("No country data for '" + countryCode + "'");
      }
    },
    // select the given flag, update the placeholder and the active list item
    // Note: called from _setInitialState, _updateFlagFromNumber, _selectListItem, setCountry
    _setFlag: function _setFlag(countryCode, isInit) {
      var prevCountry = this.selectedCountryData && this.selectedCountryData.iso2 ? this.selectedCountryData : {}; // do this first as it will throw an error and stop if countryCode is invalid

      this.selectedCountryData = countryCode ? this._getCountryData(countryCode, false, false) : {}; // update the defaultCountry - we only need the iso2 from now on, so just store that

      if (this.selectedCountryData.iso2) {
        this.defaultCountry = this.selectedCountryData.iso2;
      }

      this.selectedFlagInner.attr("class", "iti-flag " + countryCode); // update the selected country's title attribute

      var title = countryCode ? this.selectedCountryData.name + ": +" + this.selectedCountryData.dialCode : "Unknown";
      this.selectedFlagInner.parent().attr("title", title);

      if (this.options.separateDialCode) {
        var dialCode = this.selectedCountryData.dialCode ? "+" + this.selectedCountryData.dialCode : "",
            parent = this.telInput.parent();

        if (prevCountry.dialCode) {
          parent.removeClass("iti-sdc-" + (prevCountry.dialCode.length + 1));
        }

        if (dialCode) {
          parent.addClass("iti-sdc-" + dialCode.length);
        }

        this.selectedDialCode.text(dialCode);
      } // and the input's placeholder


      this._updatePlaceholder(); // update the active list item


      this.countryListItems.removeClass("active");

      if (countryCode) {
        this.countryListItems.find(".iti-flag." + countryCode).first().closest(".country").addClass("active");
      } // on change flag, trigger a custom event


      if (!isInit && prevCountry.iso2 !== countryCode) {
        this.telInput.trigger("countrychange", this.selectedCountryData);
      }
    },
    // update the input placeholder to an example number from the currently selected country
    _updatePlaceholder: function _updatePlaceholder() {
      if (window.intlTelInputUtils && !this.hadInitialPlaceholder && this.options.autoPlaceholder && this.selectedCountryData) {
        var numberType = intlTelInputUtils.numberType[this.options.numberType],
            placeholder = this.selectedCountryData.iso2 ? intlTelInputUtils.getExampleNumber(this.selectedCountryData.iso2, this.options.nationalMode, numberType) : "";
        placeholder = this._beforeSetNumber(placeholder);

        if (typeof this.options.customPlaceholder === "function") {
          placeholder = this.options.customPlaceholder(placeholder, this.selectedCountryData);
        }

        this.telInput.attr("placeholder", placeholder);
      }
    },
    // called when the user selects a list item from the dropdown
    _selectListItem: function _selectListItem(listItem) {
      // update selected flag and active list item
      this._setFlag(listItem.attr("data-country-code"));

      this._closeDropdown();

      this._updateDialCode(listItem.attr("data-dial-code"), true); // focus the input


      this.telInput.focus(); // fix for FF and IE11 (with nationalMode=false i.e. auto inserting dial code), who try to put the cursor at the beginning the first time

      if (this.isGoodBrowser) {
        var len = this.telInput.val().length;
        this.telInput[0].setSelectionRange(len, len);
      }
    },
    // close the dropdown and unbind any listeners
    _closeDropdown: function _closeDropdown() {
      this.countryList.addClass("hide"); // update the arrow

      this.selectedFlagInner.children(".iti-arrow").removeClass("up"); // unbind key events

      $(document).off(this.ns); // unbind click-off-to-close

      $("html").off(this.ns); // unbind hover and click listeners

      this.countryList.off(this.ns); // remove menu from container

      if (this.options.dropdownContainer) {
        if (!this.isMobile) {
          $(window).off("scroll" + this.ns);
        }

        this.dropdown.detach();
      }
    },
    // check if an element is visible within it's container, else scroll until it is
    _scrollTo: function _scrollTo(element, middle) {
      var container = this.countryList,
          containerHeight = container.height(),
          containerTop = container.offset().top,
          containerBottom = containerTop + containerHeight,
          elementHeight = element.outerHeight(),
          elementTop = element.offset().top,
          elementBottom = elementTop + elementHeight,
          newScrollTop = elementTop - containerTop + container.scrollTop(),
          middleOffset = containerHeight / 2 - elementHeight / 2;

      if (elementTop < containerTop) {
        // scroll up
        if (middle) {
          newScrollTop -= middleOffset;
        }

        container.scrollTop(newScrollTop);
      } else if (elementBottom > containerBottom) {
        // scroll down
        if (middle) {
          newScrollTop += middleOffset;
        }

        var heightDifference = containerHeight - elementHeight;
        container.scrollTop(newScrollTop - heightDifference);
      }
    },
    // replace any existing dial code with the new one
    // Note: called from _selectListItem and setCountry
    _updateDialCode: function _updateDialCode(newDialCode, hasSelectedListItem) {
      var inputVal = this.telInput.val(),
          newNumber; // save having to pass this every time

      newDialCode = "+" + newDialCode;

      if (inputVal.charAt(0) == "+") {
        // there's a plus so we're dealing with a replacement (doesn't matter if nationalMode or not)
        var prevDialCode = this._getDialCode(inputVal);

        if (prevDialCode) {
          // current number contains a valid dial code, so replace it
          newNumber = inputVal.replace(prevDialCode, newDialCode);
        } else {
          // current number contains an invalid dial code, so ditch it
          // (no way to determine where the invalid dial code ends and the rest of the number begins)
          newNumber = newDialCode;
        }
      } else if (this.options.nationalMode || this.options.separateDialCode) {
        // don't do anything
        return;
      } else {
        // nationalMode is disabled
        if (inputVal) {
          // there is an existing value with no dial code: prefix the new dial code
          newNumber = newDialCode + inputVal;
        } else if (hasSelectedListItem || !this.options.autoHideDialCode) {
          // no existing value and either they've just selected a list item, or autoHideDialCode is disabled: insert new dial code
          newNumber = newDialCode;
        } else {
          return;
        }
      }

      this.telInput.val(newNumber);
    },
    // try and extract a valid international dial code from a full telephone number
    // Note: returns the raw string inc plus character and any whitespace/dots etc
    _getDialCode: function _getDialCode(number) {
      var dialCode = ""; // only interested in international numbers (starting with a plus)

      if (number.charAt(0) == "+") {
        var numericChars = ""; // iterate over chars

        for (var i = 0; i < number.length; i++) {
          var c = number.charAt(i); // if char is number

          if ($.isNumeric(c)) {
            numericChars += c; // if current numericChars make a valid dial code

            if (this.countryCodes[numericChars]) {
              // store the actual raw string (useful for matching later)
              dialCode = number.substr(0, i + 1);
            } // longest dial code is 4 chars


            if (numericChars.length == 4) {
              break;
            }
          }
        }
      }

      return dialCode;
    },
    // get the input val, adding the dial code if separateDialCode is enabled
    _getFullNumber: function _getFullNumber() {
      var prefix = this.options.separateDialCode ? "+" + this.selectedCountryData.dialCode : "";
      return prefix + this.telInput.val();
    },
    // remove the dial code if separateDialCode is enabled
    _beforeSetNumber: function _beforeSetNumber(number) {
      if (this.options.separateDialCode) {
        var dialCode = this._getDialCode(number);

        if (dialCode) {
          // US dialCode is "+1", which is what we want
          // CA dialCode is "+1 123", which is wrong - should be "+1" (as it has multiple area codes)
          // AS dialCode is "+1 684", which is what we want
          // Solution: if the country has area codes, then revert to just the dial code
          if (this.selectedCountryData.areaCodes !== null) {
            dialCode = "+" + this.selectedCountryData.dialCode;
          } // a lot of numbers will have a space separating the dial code and the main number, and some NANP numbers will have a hyphen e.g. +1 684-733-1234 - in both cases we want to get rid of it
          // NOTE: don't just trim all non-numerics as may want to preserve an open parenthesis etc


          var start = number[dialCode.length] === " " || number[dialCode.length] === "-" ? dialCode.length + 1 : dialCode.length;
          number = number.substr(start);
        }
      }

      return this._cap(number);
    },

    /********************
    *  PUBLIC METHODS
    ********************/
    // this is called when the geoip call returns
    handleAutoCountry: function handleAutoCountry() {
      if (this.options.initialCountry === "auto") {
        // we must set this even if there is an initial val in the input: in case the initial val is invalid and they delete it - they should see their auto country
        this.defaultCountry = $.fn[pluginName].autoCountry; // if there's no initial value in the input, then update the flag

        if (!this.telInput.val()) {
          this.setCountry(this.defaultCountry);
        }

        this.autoCountryDeferred.resolve();
      }
    },
    // remove plugin
    destroy: function destroy() {
      if (this.allowDropdown) {
        // make sure the dropdown is closed (and unbind listeners)
        this._closeDropdown(); // click event to open dropdown


        this.selectedFlagInner.parent().off(this.ns); // label click hack

        this.telInput.closest("label").off(this.ns);
      } // unbind submit event handler on form


      if (this.options.autoHideDialCode) {
        var form = this.telInput.prop("form");

        if (form) {
          $(form).off(this.ns);
        }
      } // unbind all events: key events, and focus/blur events if autoHideDialCode=true


      this.telInput.off(this.ns); // remove markup (but leave the original input)

      var container = this.telInput.parent();
      container.before(this.telInput).remove();
    },
    // get the extension from the current number
    getExtension: function getExtension() {
      if (window.intlTelInputUtils) {
        return intlTelInputUtils.getExtension(this._getFullNumber(), this.selectedCountryData.iso2);
      }

      return "";
    },
    // format the number to the given format
    getNumber: function getNumber(format) {
      if (window.intlTelInputUtils) {
        return intlTelInputUtils.formatNumber(this._getFullNumber(), this.selectedCountryData.iso2, format);
      }

      return "";
    },
    // get the type of the entered number e.g. landline/mobile
    getNumberType: function getNumberType() {
      if (window.intlTelInputUtils) {
        return intlTelInputUtils.getNumberType(this._getFullNumber(), this.selectedCountryData.iso2);
      }

      return -99;
    },
    // get the country data for the currently selected flag
    getSelectedCountryData: function getSelectedCountryData() {
      // if this is undefined, the plugin will return it's instance instead, so in that case an empty object makes more sense
      return this.selectedCountryData || {};
    },
    // get the validation error
    getValidationError: function getValidationError() {
      if (window.intlTelInputUtils) {
        return intlTelInputUtils.getValidationError(this._getFullNumber(), this.selectedCountryData.iso2);
      }

      return -99;
    },
    // validate the input val - assumes the global function isValidNumber (from utilsScript)
    isValidNumber: function isValidNumber() {
      var val = $.trim(this._getFullNumber()),
          countryCode = this.options.nationalMode ? this.selectedCountryData.iso2 : "";
      return window.intlTelInputUtils ? intlTelInputUtils.isValidNumber(val, countryCode) : null;
    },
    // update the selected flag, and update the input val accordingly
    setCountry: function setCountry(countryCode) {
      countryCode = countryCode.toLowerCase(); // check if already selected

      if (!this.selectedFlagInner.hasClass(countryCode)) {
        this._setFlag(countryCode);

        this._updateDialCode(this.selectedCountryData.dialCode, false);
      }
    },
    // set the input value and update the flag
    // NOTE: format arg is for public method: to allow devs to format how they want
    setNumber: function setNumber(number, format) {
      // we must update the flag first, which updates this.selectedCountryData, which is used for formatting the number before displaying it
      this._updateFlagFromNumber(number);

      this._updateValFromNumber(number, $.isNumeric(format), format);
    },
    // this is called when the utils request completes
    handleUtils: function handleUtils() {
      // if the request was successful
      if (window.intlTelInputUtils) {
        // if there's an initial value in the input, then format it
        if (this.telInput.val()) {
          this._updateValFromNumber(this.telInput.val(), this.options.formatOnInit);
        }

        this._updatePlaceholder();
      }

      this.utilsScriptDeferred.resolve();
    }
  }; // using https://github.com/jquery-boilerplate/jquery-boilerplate/wiki/Extending-jQuery-Boilerplate
  // (adapted to allow public functions)

  $.fn[pluginName] = function (options) {
    var args = arguments; // Is the first parameter an object (options), or was omitted,
    // instantiate a new instance of the plugin.

    if (options === undefined || _typeof(options) === "object") {
      // collect all of the deferred objects for all instances created with this selector
      var deferreds = [];
      this.each(function () {
        if (!$.data(this, "plugin_" + pluginName)) {
          var instance = new Plugin(this, options);

          var instanceDeferreds = instance._init(); // we now have 2 deffereds: 1 for auto country, 1 for utils script


          deferreds.push(instanceDeferreds[0]);
          deferreds.push(instanceDeferreds[1]);
          $.data(this, "plugin_" + pluginName, instance);
        }
      }); // return the promise from the "master" deferred object that tracks all the others

      return $.when.apply(null, deferreds);
    } else if (typeof options === "string" && options[0] !== "_") {
      // If the first parameter is a string and it doesn't start
      // with an underscore or "contains" the `init`-function,
      // treat this as a call to a public method.
      // Cache the method call to make it possible to return a value
      var returns;
      this.each(function () {
        var instance = $.data(this, "plugin_" + pluginName); // Tests that there's already a plugin-instance
        // and checks that the requested public method exists

        if (instance instanceof Plugin && typeof instance[options] === "function") {
          // Call the method of our plugin instance,
          // and pass it the supplied arguments.
          returns = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        } // Allow instances to be destroyed via the 'destroy' method


        if (options === "destroy") {
          $.data(this, "plugin_" + pluginName, null);
        }
      }); // If the earlier cached method gives a value back return the value,
      // otherwise return this to preserve chainability.

      return returns !== undefined ? returns : this;
    }
  };
  /********************
  *  STATIC METHODS
  ********************/
  // get the country data object


  $.fn[pluginName].getCountryData = function () {
    return allCountries;
  }; // load the utils script


  $.fn[pluginName].loadUtils = function (path, utilsScriptDeferred) {
    if (!$.fn[pluginName].loadedUtilsScript) {
      // don't do this twice! (dont just check if window.intlTelInputUtils exists as if init plugin multiple times in quick succession, it may not have finished loading yet)
      $.fn[pluginName].loadedUtilsScript = true; // dont use $.getScript as it prevents caching

      $.ajax({
        url: path,
        complete: function complete() {
          // tell all instances that the utils request is complete
          $(".intl-tel-input input").intlTelInput("handleUtils");
        },
        dataType: "script",
        cache: true
      });
    } else if (utilsScriptDeferred) {
      utilsScriptDeferred.resolve();
    }
  }; // version


  $.fn[pluginName].version = "8.5.2"; // Tell JSHint to ignore this warning: "character may get silently deleted by one or more browsers"
  // jshint -W100
  // Array of country objects for the flag dropdown.
  // Each contains a name, country code (ISO 3166-1 alpha-2) and dial code.
  // Originally from https://github.com/mledoze/countries
  // then with a couple of manual re-arrangements to be alphabetical
  // then changed Kazakhstan from +76 to +7
  // and Vatican City from +379 to +39 (see issue 50)
  // and Caribean Netherlands from +5997 to +599
  // and Curacao from +5999 to +599
  // Removed:  Kosovo, Pitcairn Islands, South Georgia
  // UPDATE Sept 12th 2015
  // List of regions that have iso2 country codes, which I have chosen to omit:
  // (based on this information: https://en.wikipedia.org/wiki/List_of_country_calling_codes)
  // AQ - Antarctica - all different country codes depending on which "base"
  // BV - Bouvet Island - no calling code
  // GS - South Georgia and the South Sandwich Islands - "inhospitable collection of islands" - same flag and calling code as Falkland Islands
  // HM - Heard Island and McDonald Islands - no calling code
  // PN - Pitcairn - tiny population (56), same calling code as New Zealand
  // TF - French Southern Territories - no calling code
  // UM - United States Minor Outlying Islands - no calling code
  // UPDATE the criteria of supported countries or territories (see issue 297)
  // Have an iso2 code: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
  // Have a country calling code: https://en.wikipedia.org/wiki/List_of_country_calling_codes
  // Have a flag
  // Must be supported by libphonenumber: https://github.com/googlei18n/libphonenumber
  // Update: converted objects to arrays to save bytes!
  // Update: added "priority" for countries with the same dialCode as others
  // Update: added array of area codes for countries with the same dialCode as others
  // So each country array has the following information:
  // [
  //    Country name,
  //    iso2 code,
  //    International dial code,
  //    Order (if >1 country with same dial code),
  //    Area codes (if >1 country with same dial code)
  // ]

  var allCountries = [["Afghanistan (‫افغانستان‬‎)", "af", "93"], ["Albania (Shqipëri)", "al", "355"], ["Algeria (‫الجزائر‬‎)", "dz", "213"], ["American Samoa", "as", "1684"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Anguilla", "ai", "1264"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54"], ["Armenia (Հայաստան)", "am", "374"], ["Aruba", "aw", "297"], ["Australia", "au", "61", 0], ["Austria (Österreich)", "at", "43"], ["Azerbaijan (Azərbaycan)", "az", "994"], ["Bahamas", "bs", "1242"], ["Bahrain (‫البحرين‬‎)", "bh", "973"], ["Bangladesh (বাংলাদেশ)", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus (Беларусь)", "by", "375"], ["Belgium (België)", "be", "32"], ["Belize", "bz", "501"], ["Benin (Bénin)", "bj", "229"], ["Bermuda", "bm", "1441"], ["Bhutan (འབྲུག)", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina (Босна и Херцеговина)", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil (Brasil)", "br", "55"], ["British Indian Ocean Territory", "io", "246"], ["British Virgin Islands", "vg", "1284"], ["Brunei", "bn", "673"], ["Bulgaria (България)", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi (Uburundi)", "bi", "257"], ["Cambodia (កម្ពុជា)", "kh", "855"], ["Cameroon (Cameroun)", "cm", "237"], ["Canada", "ca", "1", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde (Kabu Verdi)", "cv", "238"], ["Caribbean Netherlands", "bq", "599", 1], ["Cayman Islands", "ky", "1345"], ["Central African Republic (République centrafricaine)", "cf", "236"], ["Chad (Tchad)", "td", "235"], ["Chile", "cl", "56"], ["China (中国)", "cn", "86"], ["Christmas Island", "cx", "61", 2], ["Cocos (Keeling) Islands", "cc", "61", 1], ["Colombia", "co", "57"], ["Comoros (‫جزر القمر‬‎)", "km", "269"], ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "cd", "243"], ["Congo (Republic) (Congo-Brazzaville)", "cg", "242"], ["Cook Islands", "ck", "682"], ["Costa Rica", "cr", "506"], ["Côte d’Ivoire", "ci", "225"], ["Croatia (Hrvatska)", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", 0], ["Cyprus (Κύπρος)", "cy", "357"], ["Czech Republic (Česká republika)", "cz", "420"], ["Denmark (Danmark)", "dk", "45"], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1767"], ["Dominican Republic (República Dominicana)", "do", "1", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt (‫مصر‬‎)", "eg", "20"], ["El Salvador", "sv", "503"], ["Equatorial Guinea (Guinea Ecuatorial)", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia (Eesti)", "ee", "372"], ["Ethiopia", "et", "251"], ["Falkland Islands (Islas Malvinas)", "fk", "500"], ["Faroe Islands (Føroyar)", "fo", "298"], ["Fiji", "fj", "679"], ["Finland (Suomi)", "fi", "358", 0], ["France", "fr", "33"], ["French Guiana (Guyane française)", "gf", "594"], ["French Polynesia (Polynésie française)", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia (საქართველო)", "ge", "995"], ["Germany (Deutschland)", "de", "49"], ["Ghana (Gaana)", "gh", "233"], ["Gibraltar", "gi", "350"], ["Greece (Ελλάδα)", "gr", "30"], ["Greenland (Kalaallit Nunaat)", "gl", "299"], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590", 0], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502"], ["Guernsey", "gg", "44", 1], ["Guinea (Guinée)", "gn", "224"], ["Guinea-Bissau (Guiné Bissau)", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509"], ["Honduras", "hn", "504"], ["Hong Kong (香港)", "hk", "852"], ["Hungary (Magyarország)", "hu", "36"], ["Iceland (Ísland)", "is", "354"], ["India (भारत)", "in", "91"], ["Indonesia", "id", "62"], ["Iran (‫ایران‬‎)", "ir", "98"], ["Iraq (‫العراق‬‎)", "iq", "964"], ["Ireland", "ie", "353"], ["Isle of Man", "im", "44", 2], ["Israel (‫ישראל‬‎)", "il", "972"], ["Italy (Italia)", "it", "39", 0], ["Jamaica", "jm", "1876"], ["Japan (日本)", "jp", "81"], ["Jersey", "je", "44", 3], ["Jordan (‫الأردن‬‎)", "jo", "962"], ["Kazakhstan (Казахстан)", "kz", "7", 1], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kuwait (‫الكويت‬‎)", "kw", "965"], ["Kyrgyzstan (Кыргызстан)", "kg", "996"], ["Laos (ລາວ)", "la", "856"], ["Latvia (Latvija)", "lv", "371"], ["Lebanon (‫لبنان‬‎)", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya (‫ليبيا‬‎)", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania (Lietuva)", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau (澳門)", "mo", "853"], ["Macedonia (FYROM) (Македонија)", "mk", "389"], ["Madagascar (Madagasikara)", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60"], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania (‫موريتانيا‬‎)", "mr", "222"], ["Mauritius (Moris)", "mu", "230"], ["Mayotte", "yt", "262", 1], ["Mexico (México)", "mx", "52"], ["Micronesia", "fm", "691"], ["Moldova (Republica Moldova)", "md", "373"], ["Monaco", "mc", "377"], ["Mongolia (Монгол)", "mn", "976"], ["Montenegro (Crna Gora)", "me", "382"], ["Montserrat", "ms", "1664"], ["Morocco (‫المغرب‬‎)", "ma", "212", 0], ["Mozambique (Moçambique)", "mz", "258"], ["Myanmar (Burma) (မြန်မာ)", "mm", "95"], ["Namibia (Namibië)", "na", "264"], ["Nauru", "nr", "674"], ["Nepal (नेपाल)", "np", "977"], ["Netherlands (Nederland)", "nl", "31"], ["New Caledonia (Nouvelle-Calédonie)", "nc", "687"], ["New Zealand", "nz", "64"], ["Nicaragua", "ni", "505"], ["Niger (Nijar)", "ne", "227"], ["Nigeria", "ng", "234"], ["Niue", "nu", "683"], ["Norfolk Island", "nf", "672"], ["North Korea (조선 민주주의 인민 공화국)", "kp", "850"], ["Northern Mariana Islands", "mp", "1670"], ["Norway (Norge)", "no", "47", 0], ["Oman (‫عُمان‬‎)", "om", "968"], ["Pakistan (‫پاکستان‬‎)", "pk", "92"], ["Palau", "pw", "680"], ["Palestine (‫فلسطين‬‎)", "ps", "970"], ["Panama (Panamá)", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru (Perú)", "pe", "51"], ["Philippines", "ph", "63"], ["Poland (Polska)", "pl", "48"], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", 3, ["787", "939"]], ["Qatar (‫قطر‬‎)", "qa", "974"], ["Réunion (La Réunion)", "re", "262", 0], ["Romania (România)", "ro", "40"], ["Russia (Россия)", "ru", "7", 0], ["Rwanda", "rw", "250"], ["Saint Barthélemy (Saint-Barthélemy)", "bl", "590", 1], ["Saint Helena", "sh", "290"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Martin (Saint-Martin (partie française))", "mf", "590", 2], ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "pm", "508"], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe (São Tomé e Príncipe)", "st", "239"], ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "sa", "966"], ["Senegal (Sénégal)", "sn", "221"], ["Serbia (Србија)", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65"], ["Sint Maarten", "sx", "1721"], ["Slovakia (Slovensko)", "sk", "421"], ["Slovenia (Slovenija)", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia (Soomaaliya)", "so", "252"], ["South Africa", "za", "27"], ["South Korea (대한민국)", "kr", "82"], ["South Sudan (‫جنوب السودان‬‎)", "ss", "211"], ["Spain (España)", "es", "34"], ["Sri Lanka (ශ්‍රී ලංකාව)", "lk", "94"], ["Sudan (‫السودان‬‎)", "sd", "249"], ["Suriname", "sr", "597"], ["Svalbard and Jan Mayen", "sj", "47", 1], ["Swaziland", "sz", "268"], ["Sweden (Sverige)", "se", "46"], ["Switzerland (Schweiz)", "ch", "41"], ["Syria (‫سوريا‬‎)", "sy", "963"], ["Taiwan (台灣)", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand (ไทย)", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tokelau", "tk", "690"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia (‫تونس‬‎)", "tn", "216"], ["Turkey (Türkiye)", "tr", "90"], ["Turkmenistan", "tm", "993"], ["Turks and Caicos Islands", "tc", "1649"], ["Tuvalu", "tv", "688"], ["U.S. Virgin Islands", "vi", "1340"], ["Uganda", "ug", "256"], ["Ukraine (Україна)", "ua", "380"], ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "ae", "971"], ["United Kingdom", "gb", "44", 0], ["United States", "us", "1", 0], ["Uruguay", "uy", "598"], ["Uzbekistan (Oʻzbekiston)", "uz", "998"], ["Vanuatu", "vu", "678"], ["Vatican City (Città del Vaticano)", "va", "39", 1], ["Venezuela", "ve", "58"], ["Vietnam (Việt Nam)", "vn", "84"], ["Wallis and Futuna", "wf", "681"], ["Western Sahara (‫الصحراء الغربية‬‎)", "eh", "212", 1], ["Yemen (‫اليمن‬‎)", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"], ["Åland Islands", "ax", "358", 1]]; // loop over all of the countries above

  for (var i = 0; i < allCountries.length; i++) {
    var c = allCountries[i];
    allCountries[i] = {
      name: c[0],
      iso2: c[1],
      dialCode: c[2],
      priority: c[3] || 0,
      areaCodes: c[4] || null
    };
  }
});